import {Formik} from 'formik'
import {useState} from 'react'
import {Form} from 'react-bootstrap'
import {useIntl} from 'react-intl'

import {InlineTable} from 'src/feature/bite/component'
import {getDate, getTimeforDate} from 'src/feature/bite/helpers/date'
import {useStore} from 'src/feature/store/hook'
import {useStoreOptionalInfoUpdate} from '../../context/useMutation'
import moment from 'moment'

const CoordinatCheck = (value: string) => {
  if (value.includes(',')) {
  }

  // @ts-ignore
  if (value.includes('..' || value.includes(',,'))) {
    return false
  }

  if (value.includes(',,') || value.includes(',.')) {
    return false
  }

  if (value.includes('.,') || value.includes('.,')) {
    return false
  }

  let latLongRegex = /^-?([0-9]{1,2}|1[0-7][0-9]|180)(\.[0-9]{1,10})$/

  if (latLongRegex.test(value) === false) {
    return false
  }
}

const StoreOptionals = ({loading}: {loading: boolean}) => {
  const intl = useIntl()
  const {detail, detailSet} = useStore()
  const [editable, setEditable] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const {mutateAsync} = useStoreOptionalInfoUpdate({storeId: detail?.id || ''})

  const Data = detail?.Optional || null

  const column = [
    [
      {
        key: 'WebSite',
        dataIndex: 'webSite',
        title: intl.formatMessage({id: 'STORE.DETAIL.OPTIONALS.WEB_SITE'}),
        edit: 'input',
      },
      {
        key: 'SeasonPeriod',
        dataIndex: 'seasonPeriod',
        title: intl.formatMessage({id: 'STORE.DETAIL.OPTIONALS.SEASON_PERIOD'}),
        yesOrNo: true,
        edit: 'select',
        selects: [
          {value: true, text: 'Yes'},
          {value: false, text: 'No'},
        ],
      },
      {
        key: 'seasonStartDate',
        dataIndex: 'seasonStartDate',
        title: intl.formatMessage({id: 'STORE.DETAIL.OPTIONALS.START_DATE'}),
        edit: 'date',
        render: (text: string) => <>{getDate(text)}</>,
      },
      {
        key: 'seasonEndDate',
        dataIndex: 'seasonEndDate',
        title: intl.formatMessage({id: 'STORE.DETAIL.OPTIONALS.END_DATE'}),
        edit: 'date',
        render: (text: string) => <>{getDate(text)}</>,
      },
    ],
    [
      {
        key: 'WorkingDays',
        dataIndex: 'workingDays',
        title: intl.formatMessage({id: 'STORE.DETAIL.OPTIONALS.WORKING_DAYS'}),
        edit: 'multiple_select',
        selects: [
          {value: 0, text: intl.formatMessage({id: 'GLOBAL.MONDAY'})},
          {value: 1, text: intl.formatMessage({id: 'GLOBAL.TUESDAY'})},
          {value: 2, text: intl.formatMessage({id: 'GLOBAL.WEDNESDAY'})},
          {value: 3, text: intl.formatMessage({id: 'GLOBAL.THURSDAY'})},
          {value: 4, text: intl.formatMessage({id: 'GLOBAL.FRIDAY'})},
          {value: 5, text: intl.formatMessage({id: 'GLOBAL.SATURDAY'})},
          {value: 6, text: intl.formatMessage({id: 'GLOBAL.SUNDAY'})},
        ],
        render: (text: any) => {
          const context: string[] = []

          text.map((item: any) => {
            switch (item) {
              case 0:
                context.push(intl.formatMessage({id: 'GLOBAL.MONDAY'}))
                break
              case 1:
                context.push(intl.formatMessage({id: 'GLOBAL.TUESDAY'}))
                break
              case 2:
                context.push(intl.formatMessage({id: 'GLOBAL.WEDNESDAY'}))
                break
              case 3:
                context.push(intl.formatMessage({id: 'GLOBAL.THURSDAY'}))
                break
              case 4:
                context.push(intl.formatMessage({id: 'GLOBAL.FRIDAY'}))
                break
              case 5:
                context.push(intl.formatMessage({id: 'GLOBAL.SATURDAY'}))
                break
              case 6:
                context.push(intl.formatMessage({id: 'GLOBAL.SUNDAY'}))
                break
            }
          })

          return <>{context.join(', ')}</>
        },
      },
      {
        key: 'openingTime',
        dataIndex: 'openingTime',
        title: intl.formatMessage({id: 'STORE.DETAIL.OPTIONALS.OPENING_HOURS'}),
        edit: 'time',
      },
      {
        key: 'closingTime',
        dataIndex: 'closingTime',
        title: intl.formatMessage({id: 'STORE.DETAIL.OPTIONALS.CLOSING_HOURS'}),
        edit: 'time',
      },
      {
        key: 'Latitude',
        dataIndex: 'latitude',
        title: intl.formatMessage({id: 'STORE.DETAIL.OPTIONALS.LATITUDE'}),
        edit: 'input',
      },
      {
        key: 'Longitude',
        dataIndex: 'longitude',
        title: intl.formatMessage({id: 'STORE.DETAIL.OPTIONALS.LONGITUDE'}),
        edit: 'input',
      },
    ],
  ]

  const handleSubmit = async (values) => {
    const input = {
      webSite: values.webSite,
      seasonPeriod: values.seasonPeriod,
      seasonStartDate: moment(values.seasonStartDate).format('MM/DD/YYYY'),
      seasonEndDate: moment(values.seasonEndDate).format('MM/DD/YYYY'),
      workingDays: values.workingDays,
      closingTime: values.closingTime,
      openingTime: values.openingTime,
      latitude: !values.latitude || values.latitude === '' ? 0 : values.latitude,
      longitude: !values.longitude || values.longitude === '' ? 0 : values.longitude,
    }

    await mutateAsync(input)
    setEditable(false)
    setIsLoading(false)

    if (!detail) return
    if (!detail.Optional) return

    detailSet({
      ...detail,
      Optional: {
        ...detail.Optional,
        ...input,
      },
    })
  }

  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header'>
        <div className='card-title m-0'>
          <div>
            <h3 className='fw-bold mb-2 mt-5'>
              {intl.formatMessage({id: 'STORE.DETAIL.OPTIONALS'})}
            </h3>
            <p className='fw-normal fs-6'>
              {intl.formatMessage({id: 'STORE.DETAIL.OPTIONALS_TOOLTIP'})}
            </p>
          </div>
        </div>
      </div>

      {Data && (
        <Formik
          key='optionals'
          initialValues={{
            webSite: Data.webSite || '',
            seasonPeriod: Data.seasonPeriod || true,
            seasonStartDate: Data.seasonStartDate,
            seasonEndDate: Data.seasonEndDate,
            workingDays: Data.workingDays || [],
            closingTime: Data.closingTime,
            openingTime: Data.openingTime,
            latitude: Data.latitude || 0,
            longitude: Data.longitude || 0,
          }}
          validate={(values) => {
            const errors: any = {}

            if (!values.openingTime || values.openingTime === 'Invalid date') {
              errors.openingTime = intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})
            }

            if (!values.closingTime || values.closingTime === 'Invalid date') {
              errors.closingTime = intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})
            }

            if (!values.webSite) {
              errors.webSite = intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})
            }

            if (values.webSite.length > 50) {
              errors.webSite = intl.formatMessage(
                {id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'},
                {
                  length: 50,
                }
              )
            }

            if (values.webSite.length < 3) {
              errors.webSite = intl.formatMessage(
                {id: 'GLOBAL.VALIDATION.MIN_LENGTH_FIELD'},
                {
                  length: 3,
                }
              )
            }

            // if (values.seasonPeriod === '' ) {
            //   errors.seasonPeriod = intl.formatMessage({ id: 'GLOBAL.VALIDATION.REQUIRED_FIELD' });
            // }

            if (!values.seasonStartDate) {
              errors.startDate = intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})
            }

            if (!values.seasonEndDate) {
              errors.endDate = intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})
            }

            if (values.workingDays.length === 0) {
              errors.workingDays = intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})
            }

            if (!values.openingTime) {
              errors.openingTime = intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})
            }

            if (!values.closingTime) {
              errors.closingTime = intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'})
            }

            // if (!values.latitude) {
            //   errors.latitude = intl.formatMessage({ id: 'GLOBAL.VALIDATION.REQUIRED_FIELD' })
            // }

            if (values.latitude && CoordinatCheck(values?.latitude.toString() || '') === false) {
              errors.latitude = intl.formatMessage(
                {id: 'GLOBAL.VALIDATION.INVALID'},
                {name: 'Latitude'}
              )
            }

            // if (!values.longitude) {
            //   errors.longitude = intl.formatMessage({ id: 'GLOBAL.VALIDATION.REQUIRED_FIELD' })
            // }

            if (values.longitude && CoordinatCheck(values?.longitude.toString() || '') === false) {
              errors.longitude = intl.formatMessage(
                {id: 'GLOBAL.VALIDATION.INVALID'},
                {name: 'Longitude'}
              )
            }

            // end date must be greater than start date
            if (values.seasonStartDate && values.seasonEndDate) {
              const seasonStartDate = new Date(values.seasonStartDate)
              const seasonEndDate = new Date(values.seasonEndDate)

              if (seasonStartDate > seasonEndDate) {
                errors.seasonEndDate = intl.formatMessage({
                  id: 'GLOBAL.VALIDATION.END_DATE_MUST_BE_GREATER_THAN_START_DATE',
                })
              }
            }

            return errors
          }}
          onSubmit={(values) => {
            handleSubmit(values)
            setIsLoading(true)
          }}
        >
          {({values, handleSubmit, resetForm}) => (
            <Form>
              <div className='card-body p-9'>
                <InlineTable
                  loading={loading}
                  dataSource={Data}
                  columns={column}
                  editable={editable}
                  values={values}
                />
              </div>
              <div className='card-footer d-flex w-100 justify-content-end'>
                {editable ? (
                  <div>
                    <button
                      className='btn btn-primary'
                      style={{marginRight: 10}}
                      onClick={() => {
                        setEditable(false)
                        resetForm()
                      }}
                    >
                      <i className='bi bi-x me-2'></i>
                      {intl.formatMessage({id: 'GLOBAL.BUTTON.CANCEL'})}
                    </button>
                    <button
                      className='btn btn-primary'
                      disabled={isLoading}
                      onClick={() => handleSubmit()}
                      type='button'
                    >
                      <i className='bi bi-save2 me-2'></i>
                      {isLoading
                        ? intl.formatMessage({id: 'GLOBAL.BUTTON.SAVING'})
                        : intl.formatMessage({id: 'GLOBAL.BUTTON.SAVE'})}
                    </button>
                  </div>
                ) : (
                  <button className='btn btn-primary' onClick={() => setEditable(true)}>
                    <i className='bi bi-pencil me-2'></i>
                    {intl.formatMessage({id: 'GLOBAL.BUTTON.EDIT'})}
                  </button>
                )}
              </div>
            </Form>
          )}
        </Formik>
      )}
    </div>
  )
}

export default StoreOptionals
